import React, {createContext, useEffect, useImperativeHandle, useState} from "react";
import PropTypes from "prop-types";


// Create a Context for our table
const ExpanderTableContext = createContext({})

const ExpanderTable = React.forwardRef(({page = 0, pageLength = 10, sorting = {}, columns=[], onData, children}, ref) => {
    const [state, setState] = useState({
        isFetching   : false,
        page         : page,
        pageLength   : pageLength,
        pageCount    : 0,
        rows         : [],
        rowsTotal    : 0,
        rowsFiltered : 0,
        sorting      : sorting,
        search       : '',
        columns      : columns,
    })

    // Expose the reload method to the parent
    useImperativeHandle(ref, ()=> ({
        reload: fetchData,
    }))

    // Fetch table data on input change...
    useEffect(() => {
        if (!onData) { return }

        let isloaded = true;

        // Set the isFetching flag
        setState(s => ({...s, isFetching: true}))

        onData(state.page, state.pageLength, state.sorting, state.search)
            .then(result => {
                if (isloaded) {
                    setState(s => ({...s, isFetching: false, ...processData(result)}))
                }
            })

        // Return a clean up function...
        return () => { isloaded = false }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[onData, state.page, state.pageLength, state.sorting, state.search])

    const fetchData = () => {
        if (!onData) { return }
        setState(s => ({...s, isFetching: true}))
        onData(state.page, state.pageLength, state.sorting, state.search)
            .then(result => {
                setState(s => ({...s, isFetching: false, ...processData(result)}))
            })
    }

    const processData = (result) => {
        //console.log('expandertable result', result);
        const rows = result.rows || [];
        const rowsTotal = result.total || rows.length;
        const rowsFiltered = result.filtered || rowsTotal;
        const pageCount = Math.ceil(rowsFiltered / state.pageLength) - 1;
        return { rows, rowsTotal, rowsFiltered, pageCount }
    }

    return (
        <ExpanderTableContext.Provider value={{state, setState}}>
            <div className="flex flex-col my-4">
                {children}
            </div>
        </ExpanderTableContext.Provider>
    )
})

ExpanderTable.propTypes = {
    onData             : PropTypes.func,
    page               : PropTypes.number,
    pageLength         : PropTypes.number,
    sorting            : PropTypes.object,
}

export { ExpanderTable, ExpanderTableContext };